import React, { useState } from "react";
import PropTypes from "prop-types";
import { FAQWrapper, QuestionsPanelWrapper, ButtonWrapper } from "./styles";
import { ExpansionPanel, Button } from "../../Elements";

const FAQ = ({ panels, defaultShowCount, header, showInTabletAndMobile }) => {
	const [showAll, setShowAll] = useState(false);
	const sliceCount = showAll ? panels.length : defaultShowCount;
	const showToggleButton = panels.length > defaultShowCount;

	const toggleShowAll = () => setShowAll(!showAll);

	return (
		<FAQWrapper showInTabletAndMobile={showInTabletAndMobile}>
			<h2 className="header">{header}</h2>
			<QuestionsPanelWrapper>
				<ExpansionPanel
					panels={panels.slice(0, sliceCount)}
					defaultShowCount={defaultShowCount}
				/>
			</QuestionsPanelWrapper>
			{showToggleButton && !showAll && (
				<ButtonWrapper>
					<Button onClick={toggleShowAll} type="outline">
						Additional FAQs
					</Button>
				</ButtonWrapper>
			)}
		</FAQWrapper>
	);
};

FAQ.propTypes = {
	header: PropTypes.string,
	panels: PropTypes.array,
	defaultShowCount: PropTypes.number,
	showInTabletAndMobile: PropTypes.bool,
};

FAQ.defaultProps = {
	header: "",
	panels: [],
	defaultShowCount: 4,
	showInTabletAndMobile: true,
};

export default FAQ;
